export default {
  default : '4px',
  rounded : '90px',
};
